import { FilterAdminResponse } from '../../api-models';
import { HTTPMethod } from '../../types/enums';
import { AdapterInterface } from '../../types/global';
import BaseAdapter from './baseAdapter';
import { FilterAdmin } from '../../types/filters.type';

export default class GetAdminFilters
  extends BaseAdapter<FilterAdminResponse[]>
  implements AdapterInterface {
  rawResponse: FilterAdminResponse[];

  async adaptResponse(): Promise<FilterAdmin[]> {
    await this.fetchApiResponse('/api/admin/filters', HTTPMethod.Get);
    return this.rawResponse.map((filter): FilterAdmin => ({
      id: filter.id,
      name: filter.name,
      displayName: filter.display_name,
      description: filter.description,
      categoryName: filter.category_name,
      categoryDisplayName: filter.category_display_name,
      subcategoryName: filter.subcategory_name,
      subcategoryDisplayName: filter.subcategory_display_name,
      featureFlag: filter.feature_flag,
    }));
  }
}
